module.exports = __webpack_public_path__ + "img/business10_E.c40d9d87.png";